import React, { useState } from "react";
import styles from "./NavBar2.module.css";
import logo from "../../assets/logo.png";
import { NavLink } from "react-router-dom";

function NavBar2(props) {
  const [openNav, setOpenNav] = useState(false);

  const openNavMenuHandler = () => {
    setOpenNav((open) => !open);
  };

  const handleMouseEnter = () => {
    setOpenNav(true);
  };

  const handleMouseLeave = () => {
    setOpenNav(false);
  };

  return (
    <div className={styles.navbar_body}>
      {/* <ToastContainer /> */}
      <NavLink to="/">
        <div className={styles.logo_wrapper}>
          <img src={logo} alt="logo" />
        </div>
      </NavLink>
      <div
        className={`${styles.hamburger} ${openNav ? styles.open : ""}`}
        onClick={openNavMenuHandler}
      >
        <div className={styles.dash}></div>
        <div className={styles.dash}></div>
        <div className={styles.dash}></div>
        {openNav && (
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className={styles.hamburger_menu}
          >
            <div className={styles.nav_header_inner}>
              <NavLink to="/motorists">
                <div className={styles.nav_header_inner_container}>
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.75 12.5C18.75 11.375 17.85 10.4 16.725 10.25C15.9 8.45 14.1 7.25 12 7.25C11.85 7.25 11.625 7.25 11.475 7.325C11.025 6.8 10.425 6.5 9.75 6.5C8.475 6.5 7.5 7.475 7.5 8.75C7.5 9.05 7.575 9.275 7.65 9.575C7.05 10.4 6.75 11.375 6.75 12.5C6.75 13.625 7.05 14.6 7.65 15.425C7.575 15.725 7.5 15.95 7.5 16.25C7.5 17.525 8.475 18.5 9.75 18.5C10.425 18.5 11.025 18.2 11.475 17.675C11.625 17.675 11.85 17.75 12 17.75C14.1 17.75 15.9 16.475 16.725 14.75C17.85 14.6 18.75 13.625 18.75 12.5ZM9.75 8C10.2 8 10.5 8.3 10.5 8.75C10.5 9.2 10.2 9.5 9.75 9.5C9.3 9.5 9 9.2 9 8.75C9 8.3 9.3 8 9.75 8ZM9.75 17C9.3 17 9 16.7 9 16.25C9 15.8 9.3 15.5 9.75 15.5C10.2 15.5 10.5 15.8 10.5 16.25C10.5 16.7 10.2 17 9.75 17ZM12 16.25C12 14.975 11.025 14 9.75 14C9.375 14 9 14.075 8.7 14.3C8.4 13.775 8.25 13.175 8.25 12.5C8.25 11.825 8.4 11.225 8.7 10.7C9 10.925 9.375 11 9.75 11C11.025 11 12 10.025 12 8.75C13.425 8.75 14.55 9.5 15.225 10.625C14.625 11.075 14.25 11.75 14.25 12.5C14.25 13.25 14.625 13.925 15.225 14.375C14.55 15.5 13.425 16.25 12 16.25ZM16.5 13.25C16.05 13.25 15.75 12.95 15.75 12.5C15.75 12.05 16.05 11.75 16.5 11.75C16.95 11.75 17.25 12.05 17.25 12.5C17.25 12.95 16.95 13.25 16.5 13.25Z"
                      fill="#008069"
                    />
                    <path
                      d="M12 23.7499C11.85 23.7499 11.775 23.7499 11.625 23.6749L2.625 18.4249C2.4 18.2749 2.25 18.0499 2.25 17.7499V7.2499C2.25 6.9499 2.4 6.7249 2.625 6.5749L11.625 1.3249C11.85 1.1749 12.15 1.1749 12.375 1.3249L21.375 6.5749L20.625 7.8499L12 2.8999L3.75 7.6999V17.3749L12 22.1749L20.25 17.3749V11.7499H21.75V17.7499C21.75 18.0499 21.6 18.2749 21.375 18.4249L12.375 23.6749C12.225 23.7499 12.15 23.7499 12 23.7499Z"
                      fill="#008069"
                    />
                  </svg>
                  <div className={styles.menu_text}>
                    <h1>SmartCar</h1>
                    <p>All-in-one app for car owners</p>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className={styles.nav_header_inner}>
              <NavLink to="/auto-sure-pro">
                <div className={styles.nav_header_inner_container}>
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_7959_28891)">
                      <path
                        d="M10.2883 4.19075L9.11998 5.78003H6.39166C6.72814 6.74003 7.82974 7.64531 9.36814 7.34483C9.82414 7.31411 11.3625 7.06979 12 7.22003C12.8486 7.42355 12.4949 7.42451 14.0165 8.64563L21.6 14.9C22.0646 15.3104 22.6589 15.1424 23.0702 14.6787C23.4816 14.2141 23.5046 13.3904 23.04 12.98L13.44 5.30003C12.839 4.81763 12.6873 4.14947 12.48 3.38003C12.0768 2.05763 10.5941 0.996826 9.1387 0.996826C7.96606 0.996826 6.70414 2.01107 6.23998 2.90003H9.11998L10.2883 4.19075ZM16.8739 15.86L13.9065 10.7096C13.7894 10.496 13.4933 10.1 13.2499 10.1H4.99006C4.7467 10.1 4.45054 10.496 4.33294 10.7096L1.43998 15.86H1.36606C0.87886 15.86 0.47998 16.0371 0.47998 16.5248V20.9552C0.47998 21.4429 0.87886 21.62 1.36606 21.62H2.39998V23.1704C2.39998 23.9019 2.85022 24.5 3.58126 24.5H4.0243C4.75582 24.5 5.27998 23.9019 5.27998 23.1704V21.62H12.96V23.1704C12.96 23.9015 13.4841 24.5 14.2152 24.5H14.6582C15.3897 24.5 15.84 23.9019 15.84 23.1704V21.62H16.8739C17.3611 21.62 17.76 21.4429 17.76 20.9552V16.5248C17.76 16.0371 17.3611 15.86 16.8739 15.86ZM2.91694 19.1831C2.76955 19.1861 2.62303 19.1598 2.48596 19.1055C2.34889 19.0512 2.22404 18.9701 2.11872 18.8669C2.01339 18.7638 1.92972 18.6406 1.87259 18.5047C1.81547 18.3688 1.78604 18.2229 1.78604 18.0755C1.78604 17.928 1.81547 17.7821 1.87259 17.6462C1.92972 17.5103 2.01339 17.3871 2.11872 17.284C2.22404 17.1808 2.34889 17.0997 2.48596 17.0455C2.62303 16.9912 2.76955 16.9648 2.91694 16.9679C3.2067 16.9739 3.48256 17.0932 3.68535 17.3003C3.88815 17.5074 4.00172 17.7856 4.00172 18.0755C4.00172 18.3653 3.88815 18.6436 3.68535 18.8506C3.48256 19.0577 3.2067 19.177 2.91694 19.1831ZM3.80302 15.86L5.5987 12.1026C5.70766 11.8847 5.99662 11.54 6.23998 11.54H12C12.2433 11.54 12.5318 11.8847 12.6413 12.1026L14.4369 15.86H3.80302ZM15.323 19.1831C15.0292 19.1831 14.7474 19.0663 14.5397 18.8586C14.3319 18.6508 14.2152 18.369 14.2152 18.0752C14.2152 17.7814 14.3319 17.4996 14.5397 17.2919C14.7474 17.0841 15.0292 16.9674 15.323 16.9674C15.6168 16.9674 15.8986 17.0841 16.1064 17.2919C16.3141 17.4996 16.4309 17.7814 16.4309 18.0752C16.4309 18.369 16.3141 18.6508 16.1064 18.8586C15.8986 19.0663 15.6168 19.1831 15.323 19.1831Z"
                        fill="#008069"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_7959_28891">
                        <rect
                          width="24"
                          height="24"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  <div className={styles.menu_text}>
                    <h1>AutoSure Pro</h1>
                    <p>
                      Access, Sell & Upsell auto insurance to millions of car
                      owners
                    </p>
                  </div>
                </div>
              </NavLink>
            </div>
            <div className={styles.nav_header_inner}>
              <NavLink to="/mechanics">
                <div className={styles.nav_header_inner_container}>
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="24"
                      height="24"
                      transform="translate(0 0.5)"
                      fill="white"
                    />
                    <path
                      d="M9.61 16.61C9.61 14.53 10.59 12.69 12.1 11.5H5L6.5 7H17.5L18.72 10.66C19.56 11.03 20.3 11.57 20.91 12.24L18.92 6.5C18.72 5.92 18.16 5.5 17.5 5.5H6.5C5.84 5.5 5.28 5.92 5.08 6.5L3 12.5V20.5C3 21.05 3.45 21.5 4 21.5H5C5.55 21.5 6 21.05 6 20.5V19.5H10.29C9.86 18.63 9.61 17.65 9.61 16.61ZM6.5 16.5C5.67 16.5 5 15.83 5 15C5 14.17 5.67 13.5 6.5 13.5C7.33 13.5 8 14.17 8 15C8 15.83 7.33 16.5 6.5 16.5ZM16.11 12.11C18.61 12.11 20.61 14.11 20.61 16.61C20.61 17.5 20.36 18.32 19.92 19L23 22.11L21.61 23.5L18.5 20.43C17.8 20.86 17 21.11 16.11 21.11C13.61 21.11 11.61 19.11 11.61 16.61C11.61 14.11 13.61 12.11 16.11 12.11ZM16.11 14.11C15.6155 14.11 15.1322 14.2566 14.7211 14.5313C14.31 14.806 13.9895 15.1965 13.8003 15.6533C13.6111 16.1101 13.5616 16.6128 13.658 17.0977C13.7545 17.5827 13.9926 18.0281 14.3422 18.3778C14.6919 18.7274 15.1373 18.9655 15.6223 19.062C16.1072 19.1584 16.6099 19.1089 17.0667 18.9197C17.5235 18.7305 17.914 18.41 18.1887 17.9989C18.4634 17.5878 18.61 17.1045 18.61 16.61C18.61 15.22 17.5 14.11 16.11 14.11Z"
                      fill="#008069"
                    />
                  </svg>

                  <div className={styles.menu_text}>
                    <h1>Smart Mecho</h1>
                    <p>Grow your auto shop operations</p>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className={styles.nav_header_inner}>
              <NavLink to="/spare-parts">
                <div className={styles.nav_header_inner_container}>
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.6625 10.25L17.4615 10.178L15.759 6.986C15.4392 6.38614 14.9624 5.88447 14.3796 5.53466C13.7967 5.18484 13.1298 5.00004 12.45 5H8.163C7.37576 4.99997 6.60848 5.24769 5.96988 5.70806C5.33128 6.16843 4.85377 6.8181 4.605 7.565L3.7935 9.9995C3.11363 10.2861 2.5334 10.7668 2.12544 11.3815C1.71748 11.9963 1.49992 12.7177 1.5 13.4555V15.125C1.5 16.19 2.1345 17.105 3.045 17.5175C3.16291 18.1931 3.50871 18.8078 4.02482 19.2594C4.54092 19.711 5.19616 19.9722 5.8814 19.9993C6.56664 20.0265 7.24051 19.8181 7.79077 19.4088C8.34102 18.9996 8.73444 18.4141 8.9055 17.75H15.0945C15.2656 18.4141 15.659 18.9996 16.2092 19.4088C16.7595 19.8181 17.4334 20.0265 18.1186 19.9993C18.8038 19.9722 19.4591 19.711 19.9752 19.2594C20.4913 18.8078 20.8371 18.1931 20.955 17.5175C21.4154 17.3097 21.8061 16.9734 22.0802 16.549C22.3542 16.1246 22.5 15.6302 22.5 15.125V14.6165C22.4999 13.8424 22.2602 13.0873 21.8138 12.4548C21.3675 11.8223 20.7363 11.3435 20.007 11.084L17.742 10.2785V10.25H17.6625ZM8.163 6.5H9.75V10.25H5.2905L6.027 8.039C6.17633 7.59067 6.46302 7.20073 6.84642 6.92448C7.22981 6.64824 7.69045 6.49973 8.163 6.5ZM11.25 6.5H12.45C12.8579 6.49985 13.2582 6.6106 13.608 6.82038C13.9578 7.03017 14.244 7.3311 14.436 7.691L15.801 10.25H11.25V6.5ZM17.4045 11.75L19.5045 12.497C19.942 12.6527 20.3207 12.9401 20.5884 13.3195C20.8562 13.699 21 14.1521 21 14.6165V15.125C21 15.3875 20.91 15.629 20.76 15.821C20.5143 15.2443 20.0941 14.759 19.5585 14.4334C19.0228 14.1078 18.3986 13.9581 17.7735 14.0054C17.1485 14.0528 16.5539 14.2947 16.0734 14.6973C15.5929 15.0999 15.2506 15.6429 15.0945 16.25H8.9055C8.74944 15.6429 8.40711 15.0999 7.9266 14.6973C7.4461 14.2947 6.85155 14.0528 6.22647 14.0054C5.60139 13.9581 4.97719 14.1078 4.44154 14.4334C3.90589 14.759 3.4857 15.2443 3.24 15.821C3.08389 15.6227 2.99932 15.3774 3 15.125V13.4555C3 12.7805 3.3 12.1655 3.78 11.75H17.4045ZM4.5 17C4.5 16.6022 4.65804 16.2206 4.93934 15.9393C5.22064 15.658 5.60218 15.5 6 15.5C6.39782 15.5 6.77936 15.658 7.06066 15.9393C7.34196 16.2206 7.5 16.6022 7.5 17C7.5 17.3978 7.34196 17.7794 7.06066 18.0607C6.77936 18.342 6.39782 18.5 6 18.5C5.60218 18.5 5.22064 18.342 4.93934 18.0607C4.65804 17.7794 4.5 17.3978 4.5 17ZM18 15.5C18.3978 15.5 18.7794 15.658 19.0607 15.9393C19.342 16.2206 19.5 16.6022 19.5 17C19.5 17.3978 19.342 17.7794 19.0607 18.0607C18.7794 18.342 18.3978 18.5 18 18.5C17.6022 18.5 17.2206 18.342 16.9393 18.0607C16.658 17.7794 16.5 17.3978 16.5 17C16.5 16.6022 16.658 16.2206 16.9393 15.9393C17.2206 15.658 17.6022 15.5 18 15.5Z"
                      fill="#008069"
                    />
                  </svg>
                  <div className={styles.menu_text}>
                    <h1>Spare Parts</h1>
                    <p>A wide network to Buy & Sell Spare Parts</p>
                  </div>
                </div>
              </NavLink>
            </div>

            <div className={styles.nav_header_inner}>
              <NavLink to="/contact-us">
                <div className={styles.nav_header_inner_container}>
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 4.5V9.5H5V5.5H9V3.5H4C3.73478 3.5 3.48043 3.60536 3.29289 3.79289C3.10536 3.98043 3 4.23478 3 4.5ZM21 9.5V4.5C21 4.23478 20.8946 3.98043 20.7071 3.79289C20.5196 3.60536 20.2652 3.5 20 3.5H15V5.5H19V9.5H21ZM19 19.5H15V21.5H20C20.2652 21.5 20.5196 21.3946 20.7071 21.2071C20.8946 21.0196 21 20.7652 21 20.5V15.5H19V19.5ZM9 21.5V19.5H5V15.5H3V20.5C3 20.7652 3.10536 21.0196 3.29289 21.2071C3.48043 21.3946 3.73478 21.5 4 21.5H9ZM2 11.5H22V13.5H2V11.5Z"
                      fill="#008069"
                    />
                  </svg>

                  <div className={styles.menu_text}>
                    <h1>Contact Us</h1>
                  </div>
                </div>
              </NavLink>
            </div>
          </div>
        )}
      </div>

      <div className={styles.options}>
        {" "}
        <div className={styles.options_list}>
          <p
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            className={styles.optionModal}
            style={{ color: props.optionClassName }}
          >
            Products
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 10L10 15L15 10"
                stroke={props.optionClassName || "#495463"}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            {openNav && (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className={styles.hamburger_menu}
              >
                <div className={styles.nav_header_inner}>
                  <NavLink to="/motorists">
                    <div className={styles.nav_header_inner_container}>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.75 12.5C18.75 11.375 17.85 10.4 16.725 10.25C15.9 8.45 14.1 7.25 12 7.25C11.85 7.25 11.625 7.25 11.475 7.325C11.025 6.8 10.425 6.5 9.75 6.5C8.475 6.5 7.5 7.475 7.5 8.75C7.5 9.05 7.575 9.275 7.65 9.575C7.05 10.4 6.75 11.375 6.75 12.5C6.75 13.625 7.05 14.6 7.65 15.425C7.575 15.725 7.5 15.95 7.5 16.25C7.5 17.525 8.475 18.5 9.75 18.5C10.425 18.5 11.025 18.2 11.475 17.675C11.625 17.675 11.85 17.75 12 17.75C14.1 17.75 15.9 16.475 16.725 14.75C17.85 14.6 18.75 13.625 18.75 12.5ZM9.75 8C10.2 8 10.5 8.3 10.5 8.75C10.5 9.2 10.2 9.5 9.75 9.5C9.3 9.5 9 9.2 9 8.75C9 8.3 9.3 8 9.75 8ZM9.75 17C9.3 17 9 16.7 9 16.25C9 15.8 9.3 15.5 9.75 15.5C10.2 15.5 10.5 15.8 10.5 16.25C10.5 16.7 10.2 17 9.75 17ZM12 16.25C12 14.975 11.025 14 9.75 14C9.375 14 9 14.075 8.7 14.3C8.4 13.775 8.25 13.175 8.25 12.5C8.25 11.825 8.4 11.225 8.7 10.7C9 10.925 9.375 11 9.75 11C11.025 11 12 10.025 12 8.75C13.425 8.75 14.55 9.5 15.225 10.625C14.625 11.075 14.25 11.75 14.25 12.5C14.25 13.25 14.625 13.925 15.225 14.375C14.55 15.5 13.425 16.25 12 16.25ZM16.5 13.25C16.05 13.25 15.75 12.95 15.75 12.5C15.75 12.05 16.05 11.75 16.5 11.75C16.95 11.75 17.25 12.05 17.25 12.5C17.25 12.95 16.95 13.25 16.5 13.25Z"
                          fill="#008069"
                        />
                        <path
                          d="M12 23.7499C11.85 23.7499 11.775 23.7499 11.625 23.6749L2.625 18.4249C2.4 18.2749 2.25 18.0499 2.25 17.7499V7.2499C2.25 6.9499 2.4 6.7249 2.625 6.5749L11.625 1.3249C11.85 1.1749 12.15 1.1749 12.375 1.3249L21.375 6.5749L20.625 7.8499L12 2.8999L3.75 7.6999V17.3749L12 22.1749L20.25 17.3749V11.7499H21.75V17.7499C21.75 18.0499 21.6 18.2749 21.375 18.4249L12.375 23.6749C12.225 23.7499 12.15 23.7499 12 23.7499Z"
                          fill="#008069"
                        />
                      </svg>
                      <div className={styles.menu_text}>
                        <h1>SmartCar</h1>
                        <p>All-in-one app for car owners</p>
                      </div>
                    </div>
                  </NavLink>
                </div>

                <div className={styles.nav_header_inner}>
                  <NavLink to="/auto-sure-pro">
                    <div className={styles.nav_header_inner_container}>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_7959_28891)">
                          <path
                            d="M10.2883 4.19075L9.11998 5.78003H6.39166C6.72814 6.74003 7.82974 7.64531 9.36814 7.34483C9.82414 7.31411 11.3625 7.06979 12 7.22003C12.8486 7.42355 12.4949 7.42451 14.0165 8.64563L21.6 14.9C22.0646 15.3104 22.6589 15.1424 23.0702 14.6787C23.4816 14.2141 23.5046 13.3904 23.04 12.98L13.44 5.30003C12.839 4.81763 12.6873 4.14947 12.48 3.38003C12.0768 2.05763 10.5941 0.996826 9.1387 0.996826C7.96606 0.996826 6.70414 2.01107 6.23998 2.90003H9.11998L10.2883 4.19075ZM16.8739 15.86L13.9065 10.7096C13.7894 10.496 13.4933 10.1 13.2499 10.1H4.99006C4.7467 10.1 4.45054 10.496 4.33294 10.7096L1.43998 15.86H1.36606C0.87886 15.86 0.47998 16.0371 0.47998 16.5248V20.9552C0.47998 21.4429 0.87886 21.62 1.36606 21.62H2.39998V23.1704C2.39998 23.9019 2.85022 24.5 3.58126 24.5H4.0243C4.75582 24.5 5.27998 23.9019 5.27998 23.1704V21.62H12.96V23.1704C12.96 23.9015 13.4841 24.5 14.2152 24.5H14.6582C15.3897 24.5 15.84 23.9019 15.84 23.1704V21.62H16.8739C17.3611 21.62 17.76 21.4429 17.76 20.9552V16.5248C17.76 16.0371 17.3611 15.86 16.8739 15.86ZM2.91694 19.1831C2.76955 19.1861 2.62303 19.1598 2.48596 19.1055C2.34889 19.0512 2.22404 18.9701 2.11872 18.8669C2.01339 18.7638 1.92972 18.6406 1.87259 18.5047C1.81547 18.3688 1.78604 18.2229 1.78604 18.0755C1.78604 17.928 1.81547 17.7821 1.87259 17.6462C1.92972 17.5103 2.01339 17.3871 2.11872 17.284C2.22404 17.1808 2.34889 17.0997 2.48596 17.0455C2.62303 16.9912 2.76955 16.9648 2.91694 16.9679C3.2067 16.9739 3.48256 17.0932 3.68535 17.3003C3.88815 17.5074 4.00172 17.7856 4.00172 18.0755C4.00172 18.3653 3.88815 18.6436 3.68535 18.8506C3.48256 19.0577 3.2067 19.177 2.91694 19.1831ZM3.80302 15.86L5.5987 12.1026C5.70766 11.8847 5.99662 11.54 6.23998 11.54H12C12.2433 11.54 12.5318 11.8847 12.6413 12.1026L14.4369 15.86H3.80302ZM15.323 19.1831C15.0292 19.1831 14.7474 19.0663 14.5397 18.8586C14.3319 18.6508 14.2152 18.369 14.2152 18.0752C14.2152 17.7814 14.3319 17.4996 14.5397 17.2919C14.7474 17.0841 15.0292 16.9674 15.323 16.9674C15.6168 16.9674 15.8986 17.0841 16.1064 17.2919C16.3141 17.4996 16.4309 17.7814 16.4309 18.0752C16.4309 18.369 16.3141 18.6508 16.1064 18.8586C15.8986 19.0663 15.6168 19.1831 15.323 19.1831Z"
                            fill="#008069"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_7959_28891">
                            <rect
                              width="24"
                              height="24"
                              fill="white"
                              transform="translate(0 0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <div className={styles.menu_text}>
                        <h1>AutoSure Pro</h1>
                        <p>
                          Access, Sell & Upsell auto insurance to millions of
                          car owners
                        </p>
                      </div>
                    </div>
                  </NavLink>
                </div>

                <div className={styles.nav_header_inner}>
                  <NavLink to="/mechanics">
                    <div className={styles.nav_header_inner_container}>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.6625 10.25L17.4615 10.178L15.759 6.986C15.4392 6.38614 14.9624 5.88447 14.3796 5.53466C13.7967 5.18484 13.1298 5.00004 12.45 5H8.163C7.37576 4.99997 6.60848 5.24769 5.96988 5.70806C5.33128 6.16843 4.85377 6.8181 4.605 7.565L3.7935 9.9995C3.11363 10.2861 2.5334 10.7668 2.12544 11.3815C1.71748 11.9963 1.49992 12.7177 1.5 13.4555V15.125C1.5 16.19 2.1345 17.105 3.045 17.5175C3.16291 18.1931 3.50871 18.8078 4.02482 19.2594C4.54092 19.711 5.19616 19.9722 5.8814 19.9993C6.56664 20.0265 7.24051 19.8181 7.79077 19.4088C8.34102 18.9996 8.73444 18.4141 8.9055 17.75H15.0945C15.2656 18.4141 15.659 18.9996 16.2092 19.4088C16.7595 19.8181 17.4334 20.0265 18.1186 19.9993C18.8038 19.9722 19.4591 19.711 19.9752 19.2594C20.4913 18.8078 20.8371 18.1931 20.955 17.5175C21.4154 17.3097 21.8061 16.9734 22.0802 16.549C22.3542 16.1246 22.5 15.6302 22.5 15.125V14.6165C22.4999 13.8424 22.2602 13.0873 21.8138 12.4548C21.3675 11.8223 20.7363 11.3435 20.007 11.084L17.742 10.2785V10.25H17.6625ZM8.163 6.5H9.75V10.25H5.2905L6.027 8.039C6.17633 7.59067 6.46302 7.20073 6.84642 6.92448C7.22981 6.64824 7.69045 6.49973 8.163 6.5ZM11.25 6.5H12.45C12.8579 6.49985 13.2582 6.6106 13.608 6.82038C13.9578 7.03017 14.244 7.3311 14.436 7.691L15.801 10.25H11.25V6.5ZM17.4045 11.75L19.5045 12.497C19.942 12.6527 20.3207 12.9401 20.5884 13.3195C20.8562 13.699 21 14.1521 21 14.6165V15.125C21 15.3875 20.91 15.629 20.76 15.821C20.5143 15.2443 20.0941 14.759 19.5585 14.4334C19.0228 14.1078 18.3986 13.9581 17.7735 14.0054C17.1485 14.0528 16.5539 14.2947 16.0734 14.6973C15.5929 15.0999 15.2506 15.6429 15.0945 16.25H8.9055C8.74944 15.6429 8.40711 15.0999 7.9266 14.6973C7.4461 14.2947 6.85155 14.0528 6.22647 14.0054C5.60139 13.9581 4.97719 14.1078 4.44154 14.4334C3.90589 14.759 3.4857 15.2443 3.24 15.821C3.08389 15.6227 2.99932 15.3774 3 15.125V13.4555C3 12.7805 3.3 12.1655 3.78 11.75H17.4045ZM4.5 17C4.5 16.6022 4.65804 16.2206 4.93934 15.9393C5.22064 15.658 5.60218 15.5 6 15.5C6.39782 15.5 6.77936 15.658 7.06066 15.9393C7.34196 16.2206 7.5 16.6022 7.5 17C7.5 17.3978 7.34196 17.7794 7.06066 18.0607C6.77936 18.342 6.39782 18.5 6 18.5C5.60218 18.5 5.22064 18.342 4.93934 18.0607C4.65804 17.7794 4.5 17.3978 4.5 17ZM18 15.5C18.3978 15.5 18.7794 15.658 19.0607 15.9393C19.342 16.2206 19.5 16.6022 19.5 17C19.5 17.3978 19.342 17.7794 19.0607 18.0607C18.7794 18.342 18.3978 18.5 18 18.5C17.6022 18.5 17.2206 18.342 16.9393 18.0607C16.658 17.7794 16.5 17.3978 16.5 17C16.5 16.6022 16.658 16.2206 16.9393 15.9393C17.2206 15.658 17.6022 15.5 18 15.5Z"
                          fill="#008069"
                        />
                      </svg>
                      <div className={styles.menu_text}>
                        <h1>Smart Mecho</h1>
                        <p>Grow your auto shop operations</p>
                      </div>
                    </div>
                  </NavLink>
                </div>

                <div className={styles.nav_header_inner}>
                  <NavLink to="/spare-parts">
                    <div className={styles.nav_header_inner_container}>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width="24"
                          height="24"
                          transform="translate(0 0.5)"
                          fill="white"
                        />
                        <path
                          d="M9.61 16.61C9.61 14.53 10.59 12.69 12.1 11.5H5L6.5 7H17.5L18.72 10.66C19.56 11.03 20.3 11.57 20.91 12.24L18.92 6.5C18.72 5.92 18.16 5.5 17.5 5.5H6.5C5.84 5.5 5.28 5.92 5.08 6.5L3 12.5V20.5C3 21.05 3.45 21.5 4 21.5H5C5.55 21.5 6 21.05 6 20.5V19.5H10.29C9.86 18.63 9.61 17.65 9.61 16.61ZM6.5 16.5C5.67 16.5 5 15.83 5 15C5 14.17 5.67 13.5 6.5 13.5C7.33 13.5 8 14.17 8 15C8 15.83 7.33 16.5 6.5 16.5ZM16.11 12.11C18.61 12.11 20.61 14.11 20.61 16.61C20.61 17.5 20.36 18.32 19.92 19L23 22.11L21.61 23.5L18.5 20.43C17.8 20.86 17 21.11 16.11 21.11C13.61 21.11 11.61 19.11 11.61 16.61C11.61 14.11 13.61 12.11 16.11 12.11ZM16.11 14.11C15.6155 14.11 15.1322 14.2566 14.7211 14.5313C14.31 14.806 13.9895 15.1965 13.8003 15.6533C13.6111 16.1101 13.5616 16.6128 13.658 17.0977C13.7545 17.5827 13.9926 18.0281 14.3422 18.3778C14.6919 18.7274 15.1373 18.9655 15.6223 19.062C16.1072 19.1584 16.6099 19.1089 17.0667 18.9197C17.5235 18.7305 17.914 18.41 18.1887 17.9989C18.4634 17.5878 18.61 17.1045 18.61 16.61C18.61 15.22 17.5 14.11 16.11 14.11Z"
                          fill="#008069"
                        />
                      </svg>

                      <div className={styles.menu_text}>
                        <h1>Spare Parts</h1>
                        <p>A wide network to Buy & Sell Spare Parts</p>
                      </div>
                    </div>
                  </NavLink>
                </div>
              </div>
            )}
          </p>
        </div>
        {/* <div className={styles.options_list}>
          <p style={{ color: props.optionClassName }}>Insurance</p>
        </div>
        <div className={styles.options_list}>
          <p style={{ color: props.optionClassName }}>Support</p>
        </div> */}
      </div>
      <div className={styles.button}>
        <NavLink to="/contact-us">
          <p>Contact</p>
        </NavLink>
      </div>
    </div>
  );
}

export default NavBar2;
